import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import api from '../api/client';
import { useAuth } from '../context/AuthContext';
import RegisterForm from './RegisterForm';

export default function ChildInvitePage() {
  const { token } = useParams();
  const { user, logout } = useAuth();
  const [info, setInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!token) {
      setError('Ссылка не найдена.');
      setLoading(false);
      return;
    }
    let cancelled = false;
    (async () => {
      setLoading(true);
      setError('');
      try {
        const res = await api.get(`/auth/child-invitations/${token}/`);
        if (!cancelled) setInfo(res.data);
      } catch (e) {
        if (!cancelled) {
          setError(e.response?.data?.detail || 'Ссылка недействительна или уже использована.');
          setInfo(null);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [token]);

  if (loading) {
    return (
      <div className="loading-screen">
        <div className="spinner" />
        <p>Загрузка приглашения...</p>
      </div>
    );
  }

  if (error && !info) {
    return (
      <div className="invite-page">
        <h1>Регистрация ученика</h1>
        <div className="alert alert-error">{error}</div>
        <p className="text-secondary">
          Попросите родителя выпустить новую ссылку в кабинете родителя.
        </p>
      </div>
    );
  }

  const childName = info?.child_first_name || 'ученика';
  const parentName = info?.parent_display_name || 'Родитель';

  return (
    <div className="auth-page">
      <div className="auth-card">
        <h2>Регистрация ученика</h2>
        <p className="auth-subtitle">
          {parentName} приглашает <strong>{childName}</strong> на сайт.
          Согласие на персональные данные и пользовательское соглашение для этого аккаунта уже приняты родителем.
        </p>
        {user ? (
          <div className="alert alert-info">
            Вы вошли как <strong>{user.username}</strong>. Эта ссылка создаёт новый аккаунт ученика.
            {' '}
            <button type="button" className="btn btn-outline btn-xs" onClick={() => logout()}>
              Выйти
            </button>
          </div>
        ) : (
          <RegisterForm
            key={token}
            childToken={token}
            childFirstName={info?.child_first_name || ''}
            parentName={parentName}
          />
        )}
      </div>
    </div>
  );
}
